import PropTypes from 'prop-types'

import { hasCovidFlag } from '@helpers/offer_tile'

import { UNAVAILABLE_MESSAGE, EXCLUSIVE_FALLBACK } from './constants'
import {
  getAlertMessage,
  shouldRenderExpiryMessage,
  isExclusive
} from './helpers'
import * as styles from './styles'

const OfferTileAlert = ({ offer, isOfferIssuanceTile }) => {
  if (hasCovidFlag(offer.activeFlags)) {
    return (
      <div
        css={[styles.alert(isOfferIssuanceTile), styles.unavailable]}
        data-testid='offer-alert-covid'
      >
        {UNAVAILABLE_MESSAGE}
      </div>
    )
  }

  if (shouldRenderExpiryMessage(offer)) {
    return (
      <div
        css={styles.alert(isOfferIssuanceTile)}
        data-testid='offer-alert-expiring'
      >
        {getAlertMessage(offer.discountEndDate)}
      </div>
    )
  }

  if (isExclusive(offer)) {
    return (
      <div
        css={[styles.alert(isOfferIssuanceTile), styles.exclusive]}
        data-testid='offer-alert-exclusive'
      >
        {EXCLUSIVE_FALLBACK}
      </div>
    )
  }

  return null
}

OfferTileAlert.propTypes = {
  offer: PropTypes.shape({
    activeFlags: PropTypes.object,
    closedConsumerGroup: PropTypes.string,
    discountEndDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    expiringSoon: PropTypes.bool,
    baseRedemptionType: PropTypes.shape({
      exclusive: PropTypes.bool
    })
  }).isRequired,
  isOfferIssuanceTile: PropTypes.bool
}

OfferTileAlert.defaultProps = {
  isOfferIssuanceTile: false
}

export default OfferTileAlert
